module.exports = __webpack_public_path__ + "2f4cc31441be005e6f45395138978862.svg";